import React, { useState } from 'react';
import { UnstyledButton, Group, Text, Collapse, Divider } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import SchoolStudentsSummaryTable from './SchoolStudentsSummaryTable';

/**
 * A school roster table behind a "Show roster" toggle — collapsed by default
 * so the profile stays short for studios with many students or seasons.
 */
const CollapsibleRoster = ({ students, year, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);
  const count = `${students.length} student${students.length !== 1 ? 's' : ''}`;

  return (
    <div>
      <Divider my="md" />
      <UnstyledButton onClick={() => setOpen(o => !o)} aria-expanded={open} style={{ width: '100%' }}>
        <Group justify="space-between" wrap="nowrap">
          <Text size="sm" fw={600} style={{ color: 'var(--deep-gold)' }}>
            {open ? 'Hide roster' : `Show roster (${count})`}
          </Text>
          <IconChevronDown
            size={18}
            style={{ color: 'var(--deep-gold)', transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 150ms ease' }}
          />
        </Group>
      </UnstyledButton>
      <Collapse in={open}>
        <div style={{ marginTop: '0.75rem' }}>
          <SchoolStudentsSummaryTable students={students} year={year} />
        </div>
      </Collapse>
    </div>
  );
};

export default CollapsibleRoster;
